import React from "react";
import './Posts.css';

class Posts extends React.Component {
    render() {
        return (
            <article className="article br3 ba b--black-10 w-100 w-50-m w-50-l mw7 shadow-5 center">
                <main className="pa4 black-80">
                    <div className="measure">
                        <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
                            <div className='legend center'>
                                <legend className="f1 fw6 ph0 mh0">سلسلة بوستات عن الحياة الواقعية في المانيا عامة</legend>
                            </div>
                            <hr/>

                            <div className="ui form ma0">
                                <div className="fields">
                                    <h3>
                                        الحياه الواقعيه في المانيا الاتحاديه
                                        <br/>
                                        سيكون الحديث اليوم  على متوسط التكاليف على مستوى المدن الألمانية، علماً أن الاختلاف قد يكون واضحاً بعض الشيء بين مدن ألمانيا الغربية وألمانيا الشرقية.
                                        <br/>
                                        حتي يستطيع القادم الي المانيا القاء نظره مسبقه عن ما قد يقابله من تكاليف وحسابات هنا علي الاراضي الالمانيه 
                                        <br/>
                                        أسعار الطعام في ألمانيا بالنسبة للمطاعم تختلف حسب مكان المطعم والخدمات التي يقدمها، كما تختلف الأسعار إذا كان الطعام في المنزل
                                        <br/>
                                        سعر لتر حليب عادي في ألمانيا 70 سنت
                                        <br/>
                                        سعر كيلو الأرز الأبيض 2.15 يورو
                                        <br/>
                                        سعر كيلو الجبنة المحلية الصنع 8.90 يورو.
                                        <br/>
                                        كيلو من اللحم البقري 11 يورو
                                        <br/>
                                        عدد 12 بيضة عادية 1.80 يورو
                                        <br/>
                                        عدد ١٢ بيضه بلدي ٣ يورو ونصف
                                        <br/>
                                        كيلو من صدور الدجاج 7.30 يورو
                                        <br/>
                                        كيلو من الطماطم 2.50 يورو
                                        <br/>
                                        حبة خس 91 سنت
                                        <br/>
                                        كيلو من البطاطس 2 يورو
                                        <br/>
                                        كيلو من البرتقال 2.20 يورو
                                        <br/>
                                        كيلو من الموز 1.50 يورو
                                        <br/>
                                        كيلو من البصل 1.20 يورو
                                        <br/>
                                        علبة سجاير مارلبورو 6.40 يورو
                                        <br/>
                                        نص كيلو من الخبز الطازج 1.40 يورو
                                        <br/>
                                        وجبة عادية في مطعم 9.50 يورو
                                        <br/>
                                        زوج من الجنز ماركت لفيس 75.60 يورو
                                        <br/>
                                        زوج من الأحذية 102 يورو
                                        <br/>
                                        فستان نسائي صيفي من زاره 32 يورو
                                        <br/>
                                        سعر التذكرة العادية لمدة شهر تتراوح بين  70 يورو و ١٢٠ حسب المدن وحجمها
                                        <br/>
                                        سعر تذكرة النقل المحلي لرحلة واحدة 30 يورو
                                        <br/>
                                        تعريفه التاكس للكيلو متر 2 يورو
                                        <br/>
                                        فتحة عداد التاكس 3.50 يورو
                                        <br/>
                                        سعر لتر البنزين 1.40 يورو
                                        <br/>
                                        تكاليف السكن في ألمانيا تختلف حسب مكان السكن سواء في وسط المدينة أو خارج مركز المدينة
                                        <br/>
                                        كما يختلف سعر السكن في ألمانيا حسب مساحة السكن والأسعار كالتالي :
                                        <br/>
                                        شقة من غرفة نوم واحدة في وسط المدينة 700 يورو في الشهر
                                        <br/>
                                        شقة من غرفة نوم واحدة خارج وسط المدينة 500 يورو في الشهر
                                        <br/>
                                        شقة من ثلاث غرف خارج وسط المدينة 1000 يورو في الشهر
                                        <br/>
                                        شقة من ثلاث غرف في وسط المدينة 1400 يورو في الشهر
                                        <br/>
                                        معدل الرواتب في ألمانيا 2019
                                        <br/>
                                        معدل الأجور في ألمانيا عام 2019 يختلف حسب المدينة، كما يختلف المعدل حسب الوظيفة التي يعمل فيها الشخص
                                        <br/>
                                        لكن متوسط الدخل الشهري في ألمانيا لعام 2019 بعد خصم ضريبة الدخل يبلغ 2000 يورو الى 2200 يورو للوظائف العادية
                                        <br/>
                                        تكاليف المرافق في ألمانيا تشمل الكهرباء والمياه والقمامة و التدفئة والتبريد وأسعار الإنترنت و الكابل وما شابه
                                        <br/>
                                        تكلفة الإنترنت adsl بسرعة 60 ميجا بايت في الثانية مع مساحة جيجابايت مفتوحة 30 يورو في الشهر
                                        <br/>
                                        تكاليف التدفئة والمياه والكهرباء والتبريد والقمامة لشقة مساحتها تقريباً 100 متر 220 يورو في الشهر
                                        <br/>
                                        تكاليف الخدمات الترفيهية والرياضية في ألمانيا
                                        <br/>
                                        تبلغ رسوم زيارة نادي اللياقة البدنية لشخص واحد بالغ في ألمانيا 30 يورو
                                        <br/>
                                        تذكرة السينما حوالي 10 يورو
                                        <br/>
                                        استئجار ملعب رياضي بحجم ملعب التنس لمدة ساعة 20 يورو
                                        <br/>
                                        ...طبعا يدفع الشخص العامل هنا حوالي ٣٣ الي ٤٥ في المائة من دخله شهريا حسب الشريحه الضريبيه له للتامين الصحي والمعاشات وتأمين ضد البطاله والرعايه الخاصه لكبار السن ودفع نسبه لالمانياالشرقيه كإعانه اذا كنت في الشريحه الاولي الخ
                                        <br/>
                                        ______________________________________
                                        <br/>
                                        = لينكات لتجارب زياده
                                        <br/>
                                        <div className='lft'>
                                            <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/posts/437125866666139/'>facebook.com/../../posts/437125866666139</a>
                                        <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/posts/446653582380034/'>facebook.com/../../posts/446653582380034</a>
                                        <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/posts/653903068321750/'>facebook.com/../../posts/653903068321750</a>
                                        <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/posts/963623104016410/'>facebook.com/../../posts/963623104016410</a>
                                        <br/>
                                            <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/posts/976821629363224/'>facebook.com/../../posts/976821629363224</a>
                                        <br/>
                                        </div>
                                    </h3>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </main>
            </article>
        );
    }
}

export default Posts;
